import { createContext, useContext, type ReactNode } from "react"

const ShotLeftColumnHostContext = createContext<HTMLElement | null>(null)

export function ShotLeftColumnHostProvider({ host, children }: { host: HTMLElement | null; children: ReactNode }) {
  return <ShotLeftColumnHostContext.Provider value={host}>{children}</ShotLeftColumnHostContext.Provider>
}

export function useShotLeftColumnHost() {
  return useContext(ShotLeftColumnHostContext)
}
